import homeGetters from './getters'

export default {
  namespaced: true,
  state () {
    return {
      // Home
      homeTitle: ['Trang chủ', 'Home'],
      // Home Column1
      cl1Title: ['Đăng nhập', 'Login'],
      vnLoginBox: [
        {
          label1: 'Người dùng',
          label2: 'Mật khẩu',
          label3: 'Duy trì đăng nhập',
          button: 'Đăng nhập',
          a: 'Quên mật khẩu'
        }
      ],
      enLoginBox: [
        {
          label1: 'Username',
          label2: 'Password',
          label3: 'Remember me',
          button: 'Login',
          a: 'Forgot password'
        }
      ],
      // Home Column2
      vnCl2Content: [
        {
          title: 'Giới Thiệu',
          intro: 'Trung tâm Huấn luyện bay trực thuộc Tổng công ty Hàng không Việt Nam được thành lập vào năm 1998 với chức ' +
          'năng tổ chức công tác huấn luyện phi công, tiếp viên và nhân viên điều hành khai thác bay của Hãng HKVN.',
          link1: '/company/history-foundation',
          link1Ct: 'Chi tiết',
          fl: 'BẠN MUỐN',
          sl: 'trở thành phi công,',
          tl: 'nơi khởi đầu tuyệt vời.',
          slogan: 'Huấn luyện gắn với an toàn, chất lượng và hiệu quả',
          link2: '/admissions/student-pilot',
          link2Ct: 'Tuyển sinh',
          link3: '/training-services/pilot-training',
          link3Ct: 'Dịch vụ huấn luyện'
        }
      ],
      enCl2Content: [
        {
          title: 'Introduction',
          intro: 'The Flight Training Center under the Vietnam Airlines Corporation was established in 1998 with the function of organizing training for pilots, flight attendants, and flight operation staff of Vietnam Airlines.',
          link1: '/history-foundation',
          link1Ct: 'Detail',
          fl: 'DO YOU WANT',
          sl: 'to become a pilot,',
          tl: 'a great place to start',
          slogan: 'Training associated with safety, quality, and efficiency',
          link2: '/student-pilot',
          link2Ct: 'Admission',
          link3: '/pilot-training',
          link3Ct: 'Training services'
        }
      ],
      // Home Column3
      cl3Title: ['Thời tiết', 'weather'],
      vnWeather: [
        { location: 'Hồ Chí Minh', degree: '30℃' },
        { location: 'Hà Nội', degree: '30℃' }
      ],
      enWeather: [
        { location: 'Ho Chi Minh', degree: '30℃' },
        { location: 'Ha Noi', degree: '30℃' }
      ],
      // Information box
      vnInfoBoxTitle: ['Tin Mới Nhất', 'Dịch vụ huấn luyện'],
      enInfoBoxTitle: ['News', 'Training Services'],
      vnHomeNews: [
        {
          id: 1,
          image: 'article-1.jpg',
          link: '/',
          title: 'Tuyển dụng giáo viên kiêm nhiệm các bộ môn an toàn khai thác đợt 3',
          content: 'Tuyển dụng giáo viên kiêm nhiệm các bộ môn an toàn khai thác đợt 3',
          class: ''
        },
        {
          id: 2,
          image: 'article-2.jpg',
          link: '/',
          title: 'GIẤY PHÉP DẠY NGHỀ',
          content: 'Ngày 1/12/2017 Sở Lao động Thương binh và Xã hội đã cấp Giấy Chứng nhận đăng ký hoạt động giúp đỡ dạy nghề cho Chi nhánh Tổng Công ty hàng không Việt Nam - CTCP - Trung tâm Huấn luyện bay về đào tạo ...',
          class: 'container'
        }
      ],
      enHomeNews: [
        {
          id: 1,
          image: 'article-1.jpg',
          link: '/',
          title: 'Recruitment of Concurrent Teachers for Safety Operations Subjects Batch 3',
          content: 'Recruitment of Concurrent Teachers for Safety Operations Subjects Batch 3',
          class: ''
        },
        {
          id: 2,
          image: 'article-2.jpg',
          link: '/',
          title: 'VOCATIONAL TEACHING LICENSE',
          content: 'On December 1, 2017, the Department of Labor, Invalids and Social Affairs issued a Certificate of Activity Registration for the Vietnam Airlines Corporation - Flight Training Center for training ...',
          class: 'container'
        }
      ],
      vnHomeServices: [
        { id: 1, link: '/training-services/pilot-training', title: 'Huấn luyện phi công' },
        { id: 2, link: '/training-services/flight-attendant-training', title: 'Huấn luyện tiếp viên hàng không' },
        { id: 3, link: '/training-services/flight-operations-dispatch-personnel-training', title: 'Huấn luyện NV khai thác/điều phái bay' },
        { id: 4, link: '/training-services/soft-skills-training', title: 'Huấn luyện kĩ năng mềm' },
        { id: 5, link: '/training-services/aviation-english-training', title: 'Huấn luyện tiếng anh hàng không' },
        { id: 6, link: '/training-services/aviation-career-guidance', title: 'Hướng nghiệp hàng không' }
      ],
      enHomeServices: [
        { id: 1, link: '/training-services/pilot-training', title: 'Pilot Training' },
        { id: 2, link: '/training-services/flight-attendant-training', title: 'Flight Attendant Training' },
        { id: 3, link: '/training-services/flight-operations-dispatch-personnel-training', title: 'Flight Operations/Dispatch Training' },
        { id: 4, link: '/training-services/soft-skills-training', title: 'Soft Skills Training' },
        { id: 5, link: '/training-services/aviation-english-training', title: 'Aviation English Training' },
        { id: 6, link: '/training-services/aviation-career-guidance', title: 'Aviation Career Orientation' }
      ]
    }
  },
  getters: homeGetters
}
